import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '@context/AuthContext';

const SESSION_KEY = 'pf_yaarvi_rebrand_toast_shown';

/**
 * Once per browser session for signed-out visitors: a slim, low-key pill
 * noting Playfynd → Yaarvi with an inline log-in link.
 */
const RebrandSessionToast = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || user) return;
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
    } catch {
      return;
    }

    const timer = window.setTimeout(() => {
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
      } catch {
        /* private mode / quota */
      }

      toast.custom(
        (t) => (
          <div
            className={`pointer-events-auto flex items-center gap-2 rounded-full border border-white/10 bg-surface-900/90 px-3.5 py-1.5 text-[12px] text-white/90 shadow-lg backdrop-blur-md transition-all ${
              t.visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1'
            }`}
            role="status"
          >
            <span className="whitespace-nowrap">
              <span className="font-semibold text-white">Playfynd</span> is now{' '}
              <span className="font-semibold text-white">Yaarvi</span>.
            </span>
            <button
              type="button"
              className="font-semibold text-brand-400 hover:text-brand-300"
              onClick={() => {
                toast.dismiss(t.id);
                navigate('/login');
              }}
            >
              Log in
            </button>
            <button
              type="button"
              aria-label="Dismiss"
              className="ml-1 text-white/40 hover:text-white/80"
              onClick={() => toast.dismiss(t.id)}
            >
              ×
            </button>
          </div>
        ),
        { duration: 6000, position: 'bottom-center' }
      );
    }, 1200);

    return () => clearTimeout(timer);
  }, [loading, user, navigate]);

  return null;
};

export default RebrandSessionToast;
